<template>
    <div class="node-operate-wrapper">
        <span><i class="el-icon-edit-outline" @click="openEdit" /></span>
        <span><i class="el-icon-delete" @click="deleteNode" /></span>
    </div>
</template>
<script>
export default {
    name: "NodeOperateIcon",
    props:["nodeType"],
    methods: {
        openEdit() {
            this.$emit("edit");
        },
        deleteNode() {
            this.$emit("delete");
        }
    },
}
</script>
<style lang="less" scoped>
@import (reference) url('./rpaNode.less');
.node-operate-wrapper {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: -27px;
    top: 0;
    span {
        .span-op(18px,18px);
        box-shadow: 0 2px 6px 0 #C8D8E5;
        margin-bottom: 10px;
        i {
            font-size: 13px;
            color: #7A7E8E;
            &:hover {
                color: #2EC2FF;
            }
        }
    }
}
</style>
